import React, { Component } from 'react';

import Persona from '../Persona';

import { isMobilePortrait } from 'utils/device';

import './index.css';

export default class PersonasContainer extends Component {
	state = {
		orientation: ''
	}
	// setHeight() {
	// 	let height = 0;
	// 	Array.from(this.container.querySelectorAll('.persona')).map(child => {
	// 		const h = child.getBoundingClientRect().height;
	// 		if (h > height) height = h - 60;
	// 	});
	// 	this.setState(() => ({ height }));
	// }

	componentWillReceiveProps(nextProps) {
		const { currentPersona, updateHeight } = this.props;
		if (currentPersona !== nextProps.currentPersona) {
			const personas = Array.from(document.querySelectorAll('.persona'));
			// console.log('height', personas[nextProps.currentPersona].getBoundingClientRect().height);
			updateHeight(personas[nextProps.currentPersona].getBoundingClientRect().height);
		}
	}

	componentDidMount() {
		window.addEventListener('resize', () => {
			const resize = () => {
				if (setTimeout) clearTimeout(setTimeout);
				this.setState(() => ({ orientation: window.innerWidth > window.innerHeight ? 'landscape' : 'portrait' }));
			}
			const setTimeout = window.setTimeout(resize, 100);
		});
	}

	render() {
		const { index, sorted, personas, currentPersona, imageCredits, onRestartClick } = this.props;
		// const { height } = this.state;

		return (
			<div className={`results-container`} ref={instance => this.container = instance}>
        {sorted.map(({ personaNumber, personaNameLong, personaImageUrl, personaHexColor, description }, index) => {
					{/* if (currentPersona === index) currentPersonaColour = personaNumber; */}
					const products = personas.filter(({ archetype }) => +archetype === +personaNumber);
					return <Persona active={currentPersona === index} products={products} personaHexColor={personaHexColor} personaName={personaNameLong} description={description} currentPersona={currentPersona} imageCredits={imageCredits} onRestartClick={onRestartClick} personaImageUrl={personaImageUrl} key={`persona-${index}`} />
				})}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Results/PersonasContainer/index.js